module.exports = __webpack_public_path__ + "assets/img/102004.8eeb2768.png";